module.exports = __webpack_public_path__ + "assets/img/linux-big.a045d55a.svg";